import CoreAPIService from '../CoreAPIService';

class AncestralTabService {
    apiService;

    constructor() {
        this.apiService = new CoreAPIService();
    }

    async printProcess(data) {
        return this.apiService.post('/print/process', { ...data });
    }

    async printCheck(data) {
        return this.apiService.get('/print/check', { ...data });
    }

}

export default new AncestralTabService();
